import { enableDragDropTouch } from '@dragdroptouch/drag-drop-touch'

/**
 * HTML5 drag events never fire from touch input, so every drag the app offers -
 * reordering the sidebar, dragging crews and jobs around the schedule, moving
 * bays on the shop layout - would otherwise need a mouse. This shim watches
 * touch gestures on [draggable] elements and dispatches the drag events the
 * existing handlers already listen for.
 *
 * Press-and-hold mode keeps pages scrollable: a quick swipe that happens to
 * start on a card scrolls as normal, while holding the card for a moment picks
 * it up to drag. Holding still even longer raises contextmenu, so the
 * right-click menus on the schedule open from a long press too.
 */
export function enableTouchDragDrop() {
  enableDragDropTouch(document, document, {
    isPressHoldMode: true,

    // Attach the listeners even when the device reports no touch points, so
    // touch works on hardware that appears after load (and in browser tests,
    // which drive a desktop browser). The listeners are inert without touch.
    forceListen: true,
  })
}
